<template>
  <div class="article-item b-t b-light">
    <div class="hidden-xs article-content">
      <div class="article-left">
        <a @click="goDetails(article.id)">
          <h3 style="padding-top: 0;margin-top: 0;" class="article-name">{{article.title}}</h3>
        </a>
        <span class="block m-t">
          <span class="text-muted article-ago">{{getAgo(article.modified)}}</span>
          <a
            v-if="article.owner"
            @click="goOwner(article.owner.id)"
            class="font-bold m-l-md article-owner"
          >{{article.owner.name}}</a>
        </span>
      </div>
      <div class="article-right" v-on:click="goDetails(article.id)" style="cursor: pointer;">
        <div>
          <span class="block text-muted article-description">{{article.description}}</span>
        </div>
        <div class="img-block">
          <div class="img-container" v-bind:style="articleImageStyle"></div>
          <!-- <img v-bind:src="image"> -->
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>

    <!-- Mobile -->
    <div class="row hidden-sm hidden-md hidden-lg">
      <div v-on:click="goDetails(article.id)" style="cursor: pointer;">
        <div class="col-12 img-block">
          <div class="img-container" v-bind:style="articleImageStyle"></div>
          <!-- <img v-bind:src="image" /> -->
        </div>
        <div style="clear: both;"></div>
      </div>
      <div class="col-12">
        <a @click="goDetails(article.id)">
          <h3 style="padding-top: 0;margin-top: 0;" class="article-name">{{article.title}}</h3>
        </a>
        <div class="col-12">
          <div class="block text-muted article-description">{{article.description}}</div>
        </div>
        <div class="block m-t">
          <div class="text-muted article-ago">{{getAgo(article.modified)}}</div>
          <a
            v-if="article.owner"
            @click="goOwner(article.owner.id)"
            class="font-bold m-l-md article-owner"
          >{{article.owner.name}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shave from 'shave'
import moment from 'moment-timezone'

export default {
  name: 'articleItem',
  data() {
    return {
      win: {
        w: 0,
        h: 0
      }
    }
  },
  props: {
    article: null
  },
  created() {
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1 month',
        MM: '%d months',
        y: '1 year',
        yy: '%d years'
      }
    })
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    article: function(to) {
      this.article = to
    }
  },
  mounted() {
    this.handleResize()
  },
  computed: {
    profile() {
      return this.$store.getters.profile
    },
    articleImageStyle() {
      const fallbackImage01 = this.article.thumbs
        ? this.article.thumbs['thumb']
        : undefined
      const fallbackImage02 = this.article.thumbs
        ? this.article.thumbs['thumb-lg']
        : undefined
      const fallbackImage03 = '../../../../../vue-app/assets/img/article.svg'

      return {
        'background-image':
          'url(' +
          fallbackImage01 +
          '), ' +
          'url(' +
          fallbackImage02 +
          '), ' +
          'url(' +
          fallbackImage03 +
          ')'
      }
    }
  },
  methods: {
    handleResize() {
      this.win.w = window.innerWidth
      this.win.h = window.innerHeight
      if (this.win.w >= 1200) {
        shave('.article-name', 80, { character: '...' })
        shave('.article-description', 100, { character: '...' })
      }
      if (this.win.w >= 1024 && this.win.w < 1200) {
        shave('.article-name', 70, { character: '...' })
        shave('.article-description', 100, { character: '...' })
      }
      if (this.win.w >= 768 && this.win.w < 1024) {
        shave('.article-name', 60, { character: '...' })
        shave('.article-description', 85, { character: '...' })
      }
      if (this.win.w < 768) {
        shave('.article-name', 50, { character: '...' })
        shave('.article-description', 45, { character: '...' })
      }
    },
    getAgo(time) {
      return moment.unix(time).fromNow()
    },
    goOwner(id) {
      this.$router.push(`../${id}`)
    },
    goDetails(id) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/post/view/${id}`
      )
    },
    goContainer(id, type) {
      switch (type) {
        case 'profile':
          window.location.assign(
            `${window.user.community_url}/${window.user.community_domain}/profiles/view/${id}`
          )
          break
        case 'groups':
          window.location.assign(
            `${window.user.community_url}/${window.user.community_domain}/groups/view/${id}`
          )
          break
        case 'blog':
          window.location.assign(
            `${window.user.community_url}/${window.user.community_domain}/blog/view/${id}`
          )
          break
      }
    }
  }
}
</script>

<style lang="scss">
.lazy-image-placeholder {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
}
.lazy-image {
  max-width: 100% !important;
}
.article-item {
  margin: 20px;
  margin-left: 48px;
  padding-top: 30px;
  margin-top: 0;
}
.article-content {
  display: flex;
  justify-content: space-between;
}
.article-left {
  max-width: 250px;
  width: 250px;
}
.article-right {
  max-width: 670px;
  width: 670px;
}
.article-name {
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #000000;
}
.article-owner {
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 60%;
  display: block;
  float: left;
}
.article-ago {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  color: #888888 !important;
  display: block;
  float: left;
}
.article-description {
  float: left;
  max-width: 300px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: justify;
  color: #888888 !important;
}
.img-block {
  float: right;
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.img-block .img-container {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
@media only screen and (min-width: 1200px) {
  .img-block {
    float: right;
    padding: 0;
    margin: 0;
    width: 250px;
    height: 130px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }
}
@media only screen and (max-width: 1200px) and (min-width: 1023px) {
  .article-item {
    margin-left: 20px;
  }
  .article-left {
    max-width: 200px;
    width: 200px;
  }
  .article-right {
    max-width: 576px;
    width: 576px;
  }
  .article-name {
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    color: #000000;
  }
  .article-owner {
    width: 55%;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }
  .article-ago {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #888888 !important;
  }
  .article-description {
    max-width: 250px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    text-align: justify;
    color: #888888 !important;
  }
  .img-block {
    width: 276px;
    height: 146.37px;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .article-item {
    padding-top: 30px;
    margin: 10px;
  }
  .article-left {
    max-width: 150px;
    width: 150px;
  }
  .article-right {
    max-width: 400px;
    width: 400px;
  }
  .article-name {
    overflow: hidden;
    text-overflow: clip;
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    color: #000000;
  }
  .article-owner {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
  }
  .article-ago {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #888888 !important;
  }
  .article-description {
    max-width: 185px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: justify;
    color: #888888 !important;
  }
  .img-block {
    width: 192px;
    height: 101.37px;
  }
}
@media screen and (max-width: 767px) {
  .article-item {
    padding-left: 15px;
    padding-right: 15px;
    margin: 10px;
  }
  .article-name {
    max-width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    color: #000000;
  }
  .article-owner {
    width: 70%;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
  }
  .article-ago {
    clear: both;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #888888 !important;
  }
  .article-description {
    clear: both;
    max-width: 100%;
    margin-bottom: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    text-align: justify;
    color: #888888 !important;
  }
  .img-block {
    height: 160px;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
